import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/partners/artists/ArtistsPageClient.tsx");
